import { commonUtils } from '@/helpers/commonUtils'
import styles from './ScoreCard.module.less'
import cls from 'classnames'
import { useTranslation } from 'react-i18next'
import SubAnalysisDescriptionPopover from '../SubAnalysisDescriptionPopover/SubAnalysisDescriptionPopover'
import {
  PROFESSOR_RATE_BTN_ID_PREFIX,
  RateBtn,
} from '@/pages/ProfessorProjectDetailPage/components/ProfessorRatePanel/ProfessorRatePanel'
import { ProfessorContext } from '@/Contexts/Contexts'
import { useContext } from 'react'

interface Props {
  score: number
  meanScore: number
  mode?: 'professor' | 'default'
}
function ScoreCard({ score, meanScore, mode = 'default' }: Props) {
  const { showProfessorPanel } = useContext(ProfessorContext)
  const { t } = useTranslation()
  const _mode = score >= meanScore ? 'high' : 'low'
  const popoverDescriptions = [
    {
      title: t('dashboard.projectDetailPage.subAnalysisDescription.adVideoScore'),
      description: t('dashboard.projectDetailPage.subAnalysisDescription.adVideoScoreDesc'),
    },
    {
      title: t('dashboard.projectDetailPage.subAnalysisDescription.norm'),
      description: t('dashboard.projectDetailPage.subAnalysisDescription.normDesc'),
    },
  ]
  return (
    <div className={cls(styles.scoreCard, _mode === 'high' && styles.high)}>
      {_mode === 'high' && (
        <>
          <img
            className={styles.cardBg}
            src={commonUtils.getImagePath('projectDetailPage/project-score-bg-high.png')}
            alt=''
          />
          <img
            className={styles.focus}
            src={commonUtils.getImagePath('projectDetailPage/project-score-focus-high.png')}
            alt=''
          />
          <img
            className={styles.mark}
            src={commonUtils.getImagePath('projectDetailPage/project-score-mark-high.png')}
            alt=''
          />
        </>
      )}
      {_mode === 'low' && (
        <>
          <img
            className={styles.cardBg}
            src={commonUtils.getImagePath('projectDetailPage/project-score-bg-low.png')}
            alt=''
          />
          <img
            className={styles.focus}
            src={commonUtils.getImagePath('projectDetailPage/project-score-focus-low.png')}
            alt=''
          />
          <img
            className={styles.mark}
            src={commonUtils.getImagePath('projectDetailPage/project-score-mark-low.png')}
            alt=''
          />
        </>
      )}
      <div className={cls(styles.score, _mode === 'high' && styles.high)}>
        <p className={styles.scoreText}>{score}</p>
        <p className={styles.scoreTitle}>
          {t('dashboard.projectDetailPage.videoView.adVideoScore')}
          <SubAnalysisDescriptionPopover descriptions={popoverDescriptions} />
        </p>
        <p className={styles.meanScoreText}>
          {t('dashboard.projectDetailPage.videoView.norm')}: {meanScore}
        </p>
        {mode === 'professor' && (
          <span id={`${PROFESSOR_RATE_BTN_ID_PREFIX}-adEffIndex`}>
            <RateBtn rateKey={'ad_eff_index'} onClick={() => showProfessorPanel('ad_eff_index')} />
          </span>
        )}
      </div>
    </div>
  )
}

export default ScoreCard
